import { io, type Socket } from "socket.io-client";
import type { ClientToServerEvents, ServerToClientEvents } from "shared";

/**
 * The typed Socket.IO client. Listen events are the server->client map and
 * emit events are the client->server map (the reverse of the server's generics).
 */
export type GameSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: GameSocket | undefined;

export function connectSocket(): GameSocket {
  if (socket) return socket;
  // Same-origin; Vite proxies /socket.io to the server in dev.
  socket = io({ transports: ["websocket"], autoConnect: true });
  return socket;
}

export function getSocket(): GameSocket {
  if (!socket) throw new Error("Socket not connected");
  return socket;
}
